import React, { useState, Context, ReactElement, Component } from "react";

export interface role_type {
    roleName: string;
    workspace: string;
    namespace: string;
    cluster: string;
    // workspace: string;
    // namespace: string;
    // cluster: string;
    datacenter: string;
    subscriptionName: string;
    subscriptionId: string;
    clusterType: string;
}

const RolesContext: Context<[role_type[], React.Dispatch<React.SetStateAction<role_type[]>>]> = React.createContext<[role_type[], React.Dispatch<React.SetStateAction<role_type[]>>]>([[] as unknown as role_type[], (_value: any) => { }]);

const RolesProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [roles, set_roles]: [role_type[], React.Dispatch<React.SetStateAction<role_type[]>>] = useState([] as unknown as role_type[]);
    return (
        <RolesContext.Provider value={[roles, set_roles]}>
            {props.children}
        </RolesContext.Provider>
    )
}

export { RolesContext, RolesProvider };

